import { MdSkipNext } from 'react-icons/md';
import ComboBox from '../../components/controls/ComboBox';
import TextBox from '../../components/controls/TextBox/TextBox';
import cls from './registration-page.module.css';
import { Link } from 'react-router-dom';
import { Wizard, useWizard } from 'react-use-wizard';
import _businessService, { RegisterBusiness } from '../../services/businessService';
import { useState } from 'react';

export interface RegistrationPageProps { }

type RegisterProps = {
    business: RegisterBusiness,
    onChange: (data: RegisterBusiness) => void
}


export const RegistrationPage = (props: RegistrationPageProps) => {
    const [business, setBusiness] = useState<RegisterBusiness>({});

    return (
        <div className={cls.registrationPage}>
            <div className={cls.registerFrame}>
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p>
                                <Link to="/login" className='sign-in'>
                                    Sign in if you already have an account
                                </Link>
                            </p>

                            <div className={cls.registrationFormContainer}>
                                <div>
                                    <h3>Create Business</h3>
                                    <h6>Register your business profile</h6>
                                </div>
                                <div className="wizard-container">
                                    <Wizard>
                                        <BusinessRegistrationStep business={business} onChange={setBusiness} />
                                        <UserRegistrationStep business={business} onChange={setBusiness} />
                                    </Wizard>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

function BusinessRegistrationStep(props: RegisterProps) {
    const { nextStep } = useWizard();

    return (
        <>
            <div className="form-field">
                <label className="control-label" htmlFor="businessName">Business Name <span>*</span></label>
                <input className='form-control form-control-sm' type="text" name="businessName" id="businessName"
                    onBlur={(e) => props.onChange({ ...props.business, name: e.currentTarget.value })} />
            </div>
            <div className="form-field">
                <label className="control-label" htmlFor="businessEmail">Business email <span>*</span></label>
                <input className="form-control form-control-sm" type="email" name="businessEmail" id="businessEmail"
                    onBlur={(e) => props.onChange({ ...props.business, email: e.currentTarget.value })} />
            </div>

            <div className="form-field">
                <label className="control-label" htmlFor="businessAddress">Address</label>
                <textarea className='form-control form-control-sm' name="businessAddress" id="businessAddress" rows={2}
                    onBlur={(e) => props.onChange({ ...props.business, address: e.currentTarget.value })}></textarea>
            </div>

            <div className="row">
                <div className="col">
                    <div className="form-field">
                        <label className="control-label" htmlFor="businessDomainCode">Domain Code <span>*</span></label>
                        <input className="form-control form-control-sm" type="text" name="businessDomainCode" id="businessDomainCode"
                            onBlur={(e) => props.onChange({ ...props.business, domainCode: e.currentTarget.value })} />
                    </div>
                </div>
                <div className="col">
                    <div className="form-field">
                        <label className="control-label" htmlFor="businessPhone">Phone  <span>*</span></label>
                        <input className="form-control form-control-sm" type="phone" name="businessPhone" id="businessPhone"
                            onBlur={(e) => props.onChange({ ...props.business, phone: e.currentTarget.value })} />
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <button onClick={e => nextStep()} className='btn btn-primary'>
                        <span>Next</span>
                    </button>
                </div>
            </div>
        </>
    );
}

function UserRegistrationStep(props: RegisterProps) {
    const { previousStep } = useWizard();
    return (
        <>
            <div className="row">
                <div className="col">
                    <TextBox type='text' text='Preferred UserName'
                        onBlur={(e) => props.onChange({ ...props.business, userName: e.currentTarget.value })}></TextBox>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <TextBox type='password' text='Password'
                        onBlur={(e) => props.onChange({ ...props.business, password: e.currentTarget.value })}></TextBox>
                </div>
                <div className="col">
                    <TextBox type='password' text='Confirm Password'
                        onBlur={(e) => props.onChange({ ...props.business, confirmPassword: e.currentTarget.value })}></TextBox>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <TextBox type='text' text='Email Address'
                        onBlur={(e) => props.onChange({ ...props.business, userEmail: e.currentTarget.value })}></TextBox>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <button onClick={e => previousStep()} className='btn btn-default'>
                        <span>Previous</span>
                    </button>
                    <button className='btn btn-primary' onClick={(e) => {
                        console.log("Saving the business registration by calling the api to save");
                        const registerBusiness = async () => {
                            const res = await _businessService.registerBusiness(props.business);
                            if (res.status === true) {
                                // set the current user details in the cookie to be passed with every request
                                // set the user context for the current user profile.
                                // navigate to the login page
                                window.location.href = "/";
                            }
                            else {
                                alert("Registration was not successful. Please try again!");
                            }
                        }

                        registerBusiness();
                    }}>
                        <span>Complete</span>
                    </button>
                </div>
            </div>
        </>
    )
}